import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CountryOrStateModule } from '@shared/ui/pipes/country-or-state/country-or-state.module';
import {
  JbExpandableButtonModule,
  JbSelectListModule,
  JbTabsModule,
  JbUtilsModule,
} from 'jb-component-library';

import { JbFormWrapperModule } from '../../../../shared/form-wrapper';
import { LegendModule } from '../../../../shared/legend';
import { RegionSelectorV2Component } from './region-selector-v2.component';

const MODULES = [
  CommonModule,
  LegendModule,
  ReactiveFormsModule,
  FormsModule,
  JbTabsModule,
  JbUtilsModule,
  JbExpandableButtonModule,
  JbFormWrapperModule,
  JbSelectListModule,
  CountryOrStateModule,
];

const DECLARATIONS = [RegionSelectorV2Component];

@NgModule({
  imports: [...MODULES],
  declarations: [...DECLARATIONS],
  exports: [...DECLARATIONS],
})
export class RegionsV2Module {}
